
import React, { useCallback, useEffect, useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonLabel,
  IonList,
  IonItem,
} from '@ionic/react';
import { storeEstimateJobs } from '../utilities/ApiTasks';
import { getEstimateJobs, getSubmittedExpenses } from '../utilities/Storage';
import moment from 'moment';
import {Toolbar} from "./Toolbar";

export default function Estimates({history}) {

  const [jobs, setJobs] = useState();

  const getData = useCallback(async () => {
    await storeEstimateJobs();

    const ej = await getEstimateJobs();

    const jobItems = [];
    for (const job of ej) {
      const es = await getSubmittedExpenses(parseInt(job.id));

      if (Object.keys(es).length === 0) {
        jobItems.push(
          <IonItem 
            key={job.id}
            button={true} 
            onClick={() => history.push(`/job/${job.id}/expenses`, {job})}
            detail
          >
            <IonLabel className="ion-text-wrap">
              <h3><strong>created:</strong> {moment(job.createddatetime).format('DD/MM/YY HH:mm')}</h3>
              <h3><strong>description:</strong> {job.shortdescription}</h3>
              <p>{job.fulldescription}</p>
            </IonLabel>
          </IonItem>
        );
      }
    }

    setJobs(jobItems);
  }, []);

  useEffect(() => {
    getData();

    history.listen((test)=> {
      if (test.pathname === '/estimates') {
        getData();
      }
    });
  }, []);

  if (!jobs) {
    return null;
  }

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="Estimates" />
        <IonToolbar color="light" className="ion-padding-start ion-padding-end">
          {jobs.length === 0 ? 
          <p>No jobs require estimates at this time.</p>
          :
          <p>The following jobs require estimates.</p>
          }
        </IonToolbar>   
      </IonHeader>
      <IonContent>
        <IonList lines="full">
        {jobs}
        </IonList>
      </IonContent>
    </IonPage>
  );  

}